import { Link } from 'react-router-dom';

type Props = {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
};

export default function EmptyState({
  icon = 'ri-file-search-line',
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: Props) {
  return (
    <div className="w-full py-16 md:py-20 px-6 rounded-lg border border-dashed border-background-300 bg-background-100/60 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-full bg-background-50 border border-background-200 flex items-center justify-center">
        <i className={`${icon} text-2xl text-secondary-400`}></i>
      </div>
      <h3 className="mt-5 text-base md:text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-secondary-600 leading-6 max-w-md">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-6 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
          <i className="ri-refresh-line w-4 h-4 flex items-center justify-center"></i>
        </button>
      )}
    </div>
  );
}